export default "/assets/images/flag-ukraine.jpg?cf65170c72e5849aaa36cd9a8231c46f";